import api from "./api.service";

/** Un mois, deux années, deux grandeurs. `null` = pas de donnée, à distinguer
 *  d'un zéro mesuré : un mois sans relevé n'est pas un mois sans usage. */
export interface MoisEnergie {
  mois: number;
  montant: number | null;
  consommation: number | null;
  montantPrecedent: number | null;
  consommationPrecedente: number | null;
}

export interface SerieEnergie {
  cle: "electricite" | "gaz" | "eau";
  libelle: string;
  unite: string | null;
  /** Rythme réel de facturation, déduit des données côté serveur. L'eau est
   *  semestrielle : douze cases pour deux factures ne comparent rien. */
  periodicite: "mensuelle" | "semestrielle";
  /** L'historique de consommation est-il exploitable ? Faux dès qu'UNE facture
   *  est estimée ou de nature indéterminée — « non prouvé réel » n'est pas
   *  « réel ». La vue en € reste valable dans tous les cas. */
  consommationFiable: boolean;
  /** Date de la dernière facture relevée, pour dire depuis quand on estime. */
  dernierReleve: string | null;
  /** Combien de factures portent une consommation dont la nature n'a pas pu
   *  être lue. C'est ce que le propriétaire doit corriger pour retrouver son
   *  graphique. */
  nonQualifiees: number;
  mois: MoisEnergie[];
}

export interface ConsommationEnergie {
  annee: number;
  anneePrecedente: number;
  energies: SerieEnergie[];
}

class AnalyticsService {
  async getMonthlyExpenseAnalytics(colocId: string, year?: number) {
    const params: Record<string, string> = { colocId };
    if (year) {
      params.year = year.toString();
    }
    const response = await api.get("/analytics/expenses", { params });
    return response.data;
  }

  /** Consommation et dépense d'énergie sur deux ans. Les deux grandeurs
   *  arrivent ensemble : la bascule € / kWh est locale, sans aller-retour. */
  async getConsommationEnergie(colocId: string, annee?: number): Promise<ConsommationEnergie> {
    const params: Record<string, string> = { colocId };
    if (annee) params.annee = annee.toString();
    const response = await api.get("/analytics/energie", { params });
    return response.data;
  }

  async getMultiYearExpenseAnalytics(colocId: string, years: number[]) {
    const params = { colocId, years: years.join(',') };
    const response = await api.get("/analytics/expenses/compare", { params });
    return response.data;
  }
}

export const analyticsService = new AnalyticsService();
